import React from 'react';

import {
  COLUMN_ID,
  COLUMN_NAME,
  COLUMN_PARENT_CAMPAIGN,
  COLUMN_CAMPAIGNS,
  COLUMN_STATUS,
  COLUMN_AFFILIATE,
  COLUMN_COST_MODELS_TYPES,
  COLUMN_COST_MODELS,
  COLUMN_HAS_COST_MODELS,
  COLUMN_EXPIRATION_DATE,
  COLUMN_APPLICATION,
  COLUMN_NETWORK,
  COLUMN_PLATFORM,
  COLUMN_COUNTRY,
  COLUMN_PROMO_CODE,
  COLUMN_ACTIVITY_TYPE,
  COLUMN_TYPE,
  COLUMN_FRAUD_PROTECTIONS,
  COLUMN_LABELS,
  COLUMN_CURRENT_OWNER,
  COLUMN_LINK_TYPE,
  COLUMN_LINK_EXPIRATION_DATE,
  COLUMN_DEEP_LINK_REWARD_PACKAGE,
  COLUMN_DEEP_LINK_MULTIPLE_REDEMPTIONS,
  COLUMN_DEEP_LINK_MAX_REDEMPTIONS,
  COLUMN_LAST_UPDATED,
  COLUMN_CREATED_BY,
  COLUMN_CREATED,
  COLUMN_CPE_EVENTS,
  COLUMN_HAS_REWARDS,
} from 'scenes/Campaigns/constants';

import { getColor } from 'scenes/Campaigns/components/Status/Status';
import { ColorPreview } from 'scenes/Campaigns/components/shared';

export const columnIDProps = {
  field: COLUMN_ID,
  type: 'text',
  headerName: 'ID',
  align: 'right',
  headerAlign: 'right',
  width: 90,
  fixed: true,
};

export const columnNameProps = {
  field: COLUMN_NAME,
  type: 'link',
  headerName: 'Name',
  width: 262,
  fixed: true,
  getTooltip: (v) => v,
};

export const columnParentCampaignProps = {
  field: COLUMN_PARENT_CAMPAIGN,
  type: 'link',
  headerName: 'Parent Campaign',
  width: 262,
  getTooltip: (v) => v?.name,
};

export const columnCampaignsProps = {
  field: COLUMN_CAMPAIGNS,
  type: 'list',
  unitsLabel: 'GG IDs',
  headerName: 'GG IDs',
  width: 120,
  limit: 1,
  getItemValue: ({ id }) => id,
  sortable: false,
};

export const columnStatusProps = {
  field: COLUMN_STATUS,
  headerName: 'Status',
  type: 'status',
  width: 100,
  getStatusColor: getColor,
};

export const columnAffiliateProps = {
  field: COLUMN_AFFILIATE,
  headerName: 'Affiliate',
  width: 190,
  type: 'link',
  getTooltip: (v) => v?.name,
};

export const columnHasRewardsProps = {
  field: COLUMN_HAS_REWARDS,
  headerName: 'Rewards',
  width: 75,
  type: 'bool',
  align: 'center',
};

export const columnHasCostModelsProps = {
  field: COLUMN_HAS_COST_MODELS,
  headerName: 'Cost Model',
  width: 75,
  type: 'bool',
  align: 'center',
};

export const columnCostModelsProps = {
  field: COLUMN_COST_MODELS_TYPES,
  headerName: 'Cost Model',
  unitsLabel: 'Cost Models',
  limit: 2,
  width: 75,
  type: 'commaList',
};

export const columnCPEEventsProps = {
  field: COLUMN_CPE_EVENTS,
  headerName: 'CPE Events',
  limit: 1,
  width: 180,
  type: 'commaList',
  placeholder: 'All',
  getItemValue: (v) => v,
};

export const columnCostModelsRateProps = {
  field: COLUMN_COST_MODELS,
  headerName: 'Cost Model Rate',
  limit: 1,
  width: 188,
  type: 'list',
  unitsLabel: 'Rates',
  align: 'right',
  headerAlign: 'right',
};

export const columnApplicationProps = {
  field: COLUMN_APPLICATION,
  headerName: 'Application',
  width: 140,
  type: 'text',
  getValue: (v) => v?.name,
};

export const columnNetworkProps = {
  field: COLUMN_NETWORK,
  headerName: 'Network',
  width: 110,
  type: 'text',
  getValue: (v) => v?.name,
};

export const columnPlatformProps = {
  field: COLUMN_PLATFORM,
  headerName: 'Platform',
  width: 90,
  type: 'text',
  getValue: (v) => v?.name,
};

export const columnCountryProps = {
  field: COLUMN_COUNTRY,
  headerName: 'Country',
  width: 100,
  type: 'text',
  getValue: (v) => v?.name,
};

export const columnPromoCodeProps = {
  field: COLUMN_PROMO_CODE,
  headerName: 'Promo Code',
  width: 170,
};

export const columnActivityTypeProps = {
  field: COLUMN_ACTIVITY_TYPE,
  headerName: 'Track RE',
  width: 90,
  type: 'text',
};

export const columnTypeProps = {
  field: COLUMN_TYPE,
  headerName: 'Campaign Type',
  width: 90,
  type: 'text',
};

export const columnFraudProtectionProps = {
  field: COLUMN_FRAUD_PROTECTIONS,
  headerName: 'Fraud Protection',
  limit: 1,
  width: 100,
  type: 'commaList',
  getItemValue: (v) => v,
};

export const columnLabelsProps = {
  field: COLUMN_LABELS,
  headerName: 'Labels',
  limit: 1,
  width: 140,
  type: 'list',
  getItemIcon: (v) => <ColorPreview color={v?.color} />,
  getItemTooltip: (item) => item?.name,
};

export const columnOwnerProps = {
  field: COLUMN_CURRENT_OWNER,
  headerName: 'Owner',
  width: 150,
  type: 'text',
  getValue: (v) => v?.name,
};

export const columnLinkTypeProps = {
  field: COLUMN_LINK_TYPE,
  headerName: 'Type',
  type: 'text',
  getValue: (v) => v?.name,
};

export const columnLinkExpirationDateProps = {
  field: COLUMN_LINK_EXPIRATION_DATE,
  headerName: 'Expiration date',
  type: 'date',
  template: 'LL',
};

export const columnExpirationDateProps = {
  field: COLUMN_EXPIRATION_DATE,
  headerName: 'Expiration date',
  type: 'date',
  template: 'LL',
};

export const columnRewardPackageProps = {
  field: COLUMN_DEEP_LINK_REWARD_PACKAGE,
  headerName: 'Reward package',
  type: 'text',
};

export const columnMultipleRedemptionsProps = {
  field: COLUMN_DEEP_LINK_MULTIPLE_REDEMPTIONS,
  headerName: 'Multiple redemptions',
  type: 'bool',
  align: 'center',
};

export const columnMaxRedemptionsProps = {
  field: COLUMN_DEEP_LINK_MAX_REDEMPTIONS,
  headerName: 'Max redemptions',
  type: 'text',
};

export const columnLastUpdatedProps = {
  field: COLUMN_LAST_UPDATED,
  headerName: 'Last Updated',
  width: 135,
  type: 'date',
  template: 'LLL',
};

export const columnCreatedByProps = {
  field: COLUMN_CREATED_BY,
  headerName: 'Created by',
  width: 150,
  type: 'text',
  getValue: (v) => v?.name,
};

export const columnCreatedProps = {
  field: COLUMN_CREATED,
  headerName: 'Created',
  width: 135,
  type: 'date',
  template: 'LLL',
};

export const columnActionsProps = {
  actionsColDef: true,
  field: 'actions',
  type: 'actions',
};
